import React, { useEffect, useRef, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Sidebar } from "../Sidebar/Sidebar";
import { ClientBanner } from "../ClientBanner/ClientBanner";
import styles from "./SidebarLayout.module.css";

const BANNER_ROUTES = [
  '/entities', '/tiering', '/activities', '/engagements',
  '/financials', '/calculations', '/configurations', '/tax-form',
  '/overview',
];

export const SidebarLayout: React.FC = () => {
  const { pathname } = useLocation();
  const showBanner = BANNER_ROUTES.some(r => pathname.startsWith(r));
  const [contentOpacity, setContentOpacity] = useState(1);
  const prevPathRef = useRef(pathname);

  useEffect(() => {
    if (pathname === prevPathRef.current) return;
    prevPathRef.current = pathname;
    setContentOpacity(0);
    const t = setTimeout(() => setContentOpacity(1), 200);
    return () => clearTimeout(t);
  }, [pathname]);

  return (
    <div className={styles.layout}>
      <Sidebar />
      <div className={styles.mainContent}>
        {showBanner && <ClientBanner />}
        <div
          className={styles.contentArea}
          style={{ opacity: contentOpacity, transition: 'opacity 0.2s ease-in-out' }}
        >
          <Outlet />
        </div>
      </div>
    </div>
  );
};
